import React from "react";
import { Scale } from "lucide-react";
import OtpLogin from "../../components/OtpLogin";
import { HERO_IMAGES } from "../../lib/mockData";

export default function AttorneyLogin() {
  return (
    <OtpLogin
      role="Attorney"
      roleKey="attorney"
      subtitle="Log in to manage your firm profile, view leads, and grow your practice."
      redirectTo="/firm"
      accentIcon={Scale}
      sideImage={HERO_IMAGES.lawyerB}
      sidePoints={[
        "Build & manage your firm profile",
        "Receive high-intent innovator leads",
        "Submit changes for admin verification",
      ]}
    />
  );
}
